export class HtmlHelper {
  addMatomoCode(): void {
      const matomoScript = document.createElement("script");
      matomoScript.innerHTML = `
    /*  Matomo */
    var _paq = window._paq = window._paq || [];
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    (function() {
      var u="https://piwik-ext.vgregion.se/";
      _paq.push(['setTrackerUrl', u+'piwik.php']);
      _paq.push(['setSiteId', '267']);
      var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
      g.type='text/javascript'; g.async=true; g.src=u+'piwik.js'; s.parentNode.insertBefore(g,s);
    })();
    /* End Matomo Code */`;
      document.head.appendChild(matomoScript);
  }

  getBaseUrl(): string {
    let domain = window.location.origin;

    if (domain.toLowerCase().includes("https://fysisktillganglighet")) {
      domain = `${domain}/verktyg`;
    }

    return domain;
  }

  replaceUrlToCurrentDomain(text: string): string {
    let newText = text;

    const domain = this.getBaseUrl();

    newText = newText.replaceAll("https://riktlinjeportalenstage.vgregion.se/verktyg", domain);
    newText = newText.replaceAll("https://fysisktillganglighettest.vgregion.se/verktyg", domain);
    newText = newText.replaceAll("https://fysisktillganglighetstage.vgregion.se/verktyg", domain);
    newText = newText.replaceAll("https://fysisktillganglighet.vgregion.se/verktyg", domain);
    newText = newText.replaceAll("http://td-guideline-test.azurewebsites.net", domain);
    newText = newText.replaceAll("https://td-guideline-test.azurewebsites.net", domain);

    return newText;
  }
}